import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  FeedbackStatusEnum,
  IStyledAttributes,
  useIsMobile,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

import {
  EmptyStatusIndicatorFeedback,
  IStatusIndicatorFeedbackControl,
  StatusIndicatorFeedbackConst,
} from "../../common";

interface IFeedbackStatusCell {
  status: FeedbackStatusEnum;
}

const FeedbackStatusCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "feedback-status-cell",
})<IStatusIndicatorFeedbackControl>`
  width: fit-content;
  height: 24px;
  padding: 4px 10px;
  background-color: ${props => props.$bgColor};
  border-inline-start: 2px solid ${props => props.$leftColor};
  color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border-radius: 3px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 35px;
  }
`;

export const FeedbackStatusCell: FC<IFeedbackStatusCell> = ({ status }) => {
  const info = status
    ? StatusIndicatorFeedbackConst[status]
    : EmptyStatusIndicatorFeedback;
  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info.$translateKey, isMobile, translateLabel]);

  return (
    <FeedbackStatusCellStyled {...info}>{statusText}</FeedbackStatusCellStyled>
  );
};
